/**
 * apps/battle/client/src/terminal/components/McqOptions.tsx
 * MCQ options 1–4 rendered as tappable buttons. Keyboard 1–4 handled by
 * useKeyboard at the screen level (this component just renders + onclick).
 */
interface McqOption { option: string; text: string }
interface Props {
  options: McqOption[];
  onSelect: (option: string) => void;
  disabled?: boolean;
}

export function McqOptions({ options, onSelect, disabled }: Props) {
  return (
    <div role="listbox" aria-label="Multiple choice options">
      {options.map((opt, i) => (
        <button
          key={opt.option}
          type="button"
          className="tm-mcq-option"
          disabled={disabled}
          onClick={() => onSelect(opt.option)}
        >
          <span className="tm-mcq-option__key">[{i + 1}]</span>
          <span>{opt.text}</span>
        </button>
      ))}
    </div>
  );
}
